import { ReactNode } from 'react';

export function NotificationLayout({ children }: {children: ReactNode;}) {
	return (
		<>
			{children}
		</>
	);
}
